// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.od-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .od-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .od-page {
    padding: 16px 16px 28px;
  }
}

.od-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
  gap: 16px;
}
@media (max-width: 767px) {
  .od-header {
    flex-direction: column;
  }
}
.od-header__left {
  flex: 1;
}
.od-header__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.od-header__title {
  font-size: 26px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 640px) {
  .od-header__title {
    font-size: 20px;
  }
}
.od-header__check {
  color: rgb(105, 190, 40);
  font-size: 24px;
}
.od-header__order-num {
  color: rgb(0, 173, 208);
  font-weight: 700;
}
.od-header__meta {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #676a6c;
}
.od-header__meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.od-header__meta-item strong {
  color: #6d6e71;
}
.od-header__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 767px) {
  .od-header__actions {
    width: 100%;
  }
}

.od-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
}
.od-breadcrumb li {
  display: flex;
  align-items: center;
}
.od-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
}
.od-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.od-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.od-breadcrumb li.od-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.od-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
}
.od-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.od-btn--primary:hover {
  background: #4cae4c;
  color: #fff;
}
.od-btn--secondary {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.od-btn--secondary:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.od-btn--xs {
  padding: 4px 10px;
  font-size: 11px;
  border-radius: 4px;
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border-color: rgba(0, 173, 208, 0.15);
}
.od-btn--xs:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.od-btn--xs.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.od-status-badge {
  display: inline-block;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  border-radius: 3px;
}
.od-status-badge--paid {
  color: rgb(105, 190, 40);
  background: rgba(105, 190, 40, 0.1);
}
.od-status-badge--processing {
  color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.1);
}
.od-status-badge--cancelled {
  color: rgb(245, 67, 89);
  background: rgba(245, 67, 89, 0.1);
}

.od-layout {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
  align-items: start;
}
@media (max-width: 991px) {
  .od-layout {
    grid-template-columns: 1fr;
  }
}
.od-layout__main {
  min-width: 0;
}
.od-layout__sidebar {
  min-width: 0;
}

.od-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
}
.od-card--half {
  flex: 1;
  min-width: 250px;
}
.od-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #f1f1f2;
  border-bottom: 1px solid #e7eaec;
}
.od-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.od-card__badge {
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  background: #fff;
  padding: 2px 10px;
  border-radius: 10px;
  border: 1px solid #e7eaec;
}
.od-card__body {
  padding: 20px;
}
.od-card__body--table {
  padding: 0;
}

.od-product {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #e7eaec;
  transition: background 0.1s ease;
}
.od-product:last-child {
  border-bottom: none;
}
.od-product:hover {
  background: rgba(0, 173, 208, 0.015);
}
.od-product__img {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f1f2;
  flex-shrink: 0;
  border: 1px solid #e7eaec;
}
.od-product__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.od-product__img--comp {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(105, 190, 40, 0.06);
  border-color: rgba(105, 190, 40, 0.15);
  color: rgb(105, 190, 40);
  font-size: 20px;
}
.od-product__body {
  flex: 1;
  min-width: 0;
}
.od-product__name {
  font-size: 14px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0 0 6px;
  cursor: pointer;
  transition: color 0.15s ease;
  line-height: 1.3;
}
.od-product__name:hover {
  color: rgb(0, 173, 208);
}
.od-product__name--comp {
  color: #ccc;
  cursor: pointer;
}
.od-product__comp-tag {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  margin-left: 6px;
  vertical-align: middle;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.od-product__variants {
  margin-top: 4px;
}
.od-product__variant-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-bottom: 4px;
}
.od-product__variant-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.od-product__variant-item i {
  font-size: 10px;
  color: #ccc;
  width: 12px;
  text-align: center;
}
.od-product__variant-item strong {
  font-weight: 600;
  color: #6d6e71;
}
.od-product__variant-item--savings {
  color: rgb(105, 190, 40);
}
.od-product__variant-item--savings i, .od-product__variant-item--savings strong {
  color: rgb(105, 190, 40);
}
.od-product__variant-item--promo {
  color: rgb(245, 67, 89);
}
.od-product__variant-item--promo i, .od-product__variant-item--promo strong {
  color: rgb(245, 67, 89);
}
.od-product__admin-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border: 1px solid rgba(0, 173, 208, 0.15);
  text-decoration: none;
  transition: all 0.15s ease;
}
.od-product__admin-link:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.od-product__downloads {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.od-product__dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  border: 1px solid rgba(105, 190, 40, 0.15);
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease;
}
.od-product__dl-btn:hover {
  background: rgb(105, 190, 40);
  color: #fff;
}
.od-product__dl-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.od-product__pending {
  margin-top: 8px;
  font-size: 12px;
  color: rgb(255, 121, 0);
}
.od-product__pending i {
  margin-right: 4px;
}
.od-product__pending a {
  color: rgb(0, 173, 208);
  cursor: pointer;
  text-decoration: underline;
}
.od-product__price-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  min-width: 80px;
}
.od-product__qty {
  font-size: 11px;
  color: #ccc;
  margin-bottom: 2px;
}
.od-product__price {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-variant-numeric: tabular-nums;
}

.od-addresses {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}
@media (max-width: 767px) {
  .od-addresses {
    flex-direction: column;
  }
}

.od-address {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 13px;
  color: #676a6c;
  line-height: 1.5;
}
.od-address strong {
  color: #6d6e71;
  font-size: 14px;
}

.od-card--sticky {
  position: sticky;
  top: 20px;
}

.od-card__header--accent {
  background: #6d6e71;
  border-bottom-color: #6d6e71;
}
.od-card__header--accent .od-card__title {
  color: #fff;
}
.od-card__header--accent .od-card__title i {
  margin-right: 6px;
  opacity: 0.7;
}

.od-invoice__info {
  margin-bottom: 4px;
}
.od-invoice__info-row {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
  font-size: 12px;
}
.od-invoice__info-label {
  color: #ccc;
  font-weight: 500;
}
.od-invoice__info-value {
  color: #6d6e71;
  font-weight: 600;
}
.od-invoice__section-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #ccc;
  margin-bottom: 6px;
}
.od-invoice__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 6px 0;
  font-size: 13px;
  color: #676a6c;
}
.od-invoice__row--discount {
  font-size: 12px;
  color: rgb(105, 190, 40);
  padding: 2px 0;
}
.od-invoice__row--discount i {
  margin-right: 3px;
  font-size: 10px;
}
.od-invoice__row--total {
  font-size: 16px;
  font-weight: 700;
  color: #6d6e71;
  padding-top: 10px;
}
.od-invoice__product {
  flex: 1;
  min-width: 0;
}
.od-invoice__product-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 2px;
  line-height: 1.3;
}
.od-invoice__product-qty {
  font-size: 11px;
  color: #ccc;
}
.od-invoice__product-unit {
  display: block;
  font-size: 10px;
  color: #ccc;
  margin-top: 1px;
}
.od-invoice__amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  margin-left: 12px;
}
.od-invoice__amount--total {
  font-size: 18px;
  color: rgb(105, 190, 40);
}
.od-invoice__amount--discount {
  color: rgb(105, 190, 40);
}
.od-invoice__ship-method {
  font-size: 11px;
  color: #ccc;
  font-weight: 400;
}
.od-invoice__payment-method {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #f1f1f2;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #676a6c;
}
.od-invoice__payment-method i {
  color: #ccc;
  font-size: 14px;
}
.od-invoice__divider {
  height: 1px;
  background: #e7eaec;
  margin: 8px 0;
}

.od-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 60px 20px;
}

.pdf-modal {
  display: none;
}

@media print {
  .od-page {
    padding: 20px;
  }
  .od-header__actions {
    display: none !important;
  }
  .od-layout {
    grid-template-columns: 1fr 300px;
  }
  .od-card {
    break-inside: avoid;
  }
  .od-product__downloads,
  .od-product__pending,
  .od-product__admin-link {
    display: none !important;
  }
  .od-card__header--accent {
    background: #333 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/store-orders/order-details/order-details.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAzYA;EACE,uBAAA;EACA,iBAAA;AA4YF;AA1YE;EAJF;IAI8B,uBAAA;EA8Y5B;AACF;AA9YE;EALF;IAK8B,uBAAA;EAkZ5B;AACF;;AA5YA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AA+YF;AA7YE;EAPF;IAQI,sBAAA;EAgZF;AACF;AA9YE;EAAU,OAAA;AAiZZ;AA/YE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAiZJ;AA9YE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,wED1CS;AC0bb;AA9YI;EAPF;IAO8B,eAAA;EAkZ9B;AACF;AAhZE;EACE,wBDzBY;EC0BZ,eAAA;AAkZJ;AA/YE;EACE,uBDhCY;ECiCZ,gBAAA;AAiZJ;AA9YE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,cD1BiB;AC0arB;AA9YI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAgZN;AA9YM;EACE,cD7Ba;AC6arB;AA3YE;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA6YJ;AA3YI;EALF;IAMI,WAAA;EA8YJ;AACF;;AAtYA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;AAyYF;AAvYE;EACE,aAAA;EACA,mBAAA;AAyYJ;AAvYI;EACE,YAAA;EACA,aAAA;EACA,WD9Dc;ACucpB;AAtYI;EACE,cDzEe;EC0Ef,qBAAA;EACA,4BAAA;AAwYN;AAtYM;EAAU,uBD3FA;ACoehB;AAtYI;EACE,cD5Ee;EC6Ef,gBAAA;AAwYN;;AA/XA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDvIW;ECwIX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AAkYF;AAhYE;EACE,6BDvHY;ECwHZ,WAAA;EACA,+BDzHY;AC2fhB;AAhYI;EACE,mBDtGa;ECuGb,WAAA;AAkYN;AA9XE;EACE,gBAAA;EACA,cDvHiB;ECwHjB,qBD1GW;AC0ef;AA9XI;EACE,mBDnHgB;ECoHhB,kBDrHc;ACqfpB;AA5XE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;EACA,uBDnJY;ECoJZ,qCAAA;AA8XJ;AA5XI;EACE,4BDvJU;ECwJV,WAAA;AA8XN;AA3XI;EACE,YAAA;EACA,oBAAA;AA6XN;;AApXA;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAuXF;AArXE;EACE,wBD7KY;EC8KZ,mCAAA;AAuXJ;AApXE;EACE,uBDpLY;ECqLZ,kCAAA;AAsXJ;AAnXE;EACE,uBDtLc;ECuLd,kCAAA;AAqXJ;;AA7WA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AAgXF;AA9WE;EANF;IAOI,0BAAA;EAiXF;AACF;AA/WE;EAAU,YAAA;AAkXZ;AAjXE;EAAa,YAAA;AAoXf;;AA7WA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAgXF;AA9WE;EACE,OAAA;EACA,gBAAA;AAgXJ;AA7WE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBD9MkB;EC+MlB,gCAAA;AA+WJ;AA5WE;EACE,eAAA;EACA,gBAAA;EACA,cDxNiB;ECyNjB,SAAA;EACA,wEDlQS;ACgnBb;AA3WE;EACE,eAAA;EACA,gBAAA;EACA,cDrOiB;ECsOjB,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AA6WJ;AA1WE;EACE,aAAA;AA4WJ;AA1WI;EACE,UAAA;AA4WN;;AAnWA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,gCAAA;AAsWF;AApWE;EAAe,mBAAA;AAuWjB;AAtWE;EAAU,oCAAA;AAyWZ;AAvWE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBDhQkB;ECiQlB,cAAA;EACA,yBAAA;AAyWJ;AAvWI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAyWN;AAtWI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,wBDpSU;ECqSV,eAAA;AAwWN;AApWE;EACE,OAAA;EACA,YAAA;AAsWJ;AAnWE;EACE,eAAA;EACA,gBAAA;EACA,cDhSiB;ECiSjB,eAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AAqWJ;AAnWI;EAAU,uBDzTE;AC+pBhB;AApWI;EACE,WDvSc;ECwSd,eAAA;AAsWN;AAlWE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBDtUY;ECuUZ,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAoWJ;AAjWE;EACE,eAAA;AAmWJ;AAhWE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAkWJ;AA/VE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cDjViB;ECkVjB,wEDrXS;ACstBb;AA/VI;EACE,eAAA;EACA,WD/Uc;ECgVd,WAAA;EACA,kBAAA;AAiWN;AA9VI;EACE,gBAAA;EACA,cDxVe;ACwrBrB;AA7VI;EACE,wBD7WU;AC4sBhB;AA9VM;EAAY,wBD9WF;AC+sBhB;AA9VI;EACE,uBDjXY;ACitBlB;AA/VM;EAAY,uBDlXA;ACotBlB;AA9VE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,uBDnYY;ECoYZ,yCAAA;EACA,qBAAA;EACA,0BAAA;AAgWJ;AA9VI;EACE,4BDzYU;EC0YV,WAAA;AAgWN;AA5VE;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AA8VJ;AA3VE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,wBD5ZY;EC6ZZ,0CAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AA6VJ;AA3VI;EACE,6BDnaU;ECoaV,WAAA;AA6VN;AA1VI;EACE,YAAA;EACA,oBAAA;AA4VN;AAxVE;EACE,eAAA;EACA,eAAA;EACA,uBDjbW;AC2wBf;AAxVI;EAAI,iBAAA;AA2VR;AAzVI;EACE,uBDvbU;ECwbV,eAAA;EACA,0BAAA;AA2VN;AAvVE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AAyVJ;AAtVE;EACE,eAAA;EACA,WDlbgB;ECmbhB,kBAAA;AAwVJ;AArVE;EACE,eAAA;EACA,gBAAA;EACA,cD3biB;EC4bjB,kCAAA;AAuVJ;;AA/UA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAkVF;AAhVE;EALF;IAMI,sBAAA;EAmVF;AACF;;AAhVA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cDxdmB;ECydnB,gBAAA;AAmVF;AAjVE;EACE,cDvdiB;ECwdjB,eAAA;AAmVJ;;AA3UA;EACE,gBAAA;EACA,SAAA;AA8UF;;AA3UA;EACE,mBDtemB;ECuenB,4BDvemB;ACqzBrB;AA5UE;EACE,WAAA;AA8UJ;AA5UI;EAAI,iBAAA;EAAmB,YAAA;AAgV3B;;AA3UE;EACE,kBAAA;AA8UJ;AA3UE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AA6UJ;AA1UE;EACE,WD3fgB;EC4fhB,gBAAA;AA4UJ;AAzUE;EACE,cDlgBiB;ECmgBjB,gBAAA;AA2UJ;AAxUE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WDzgBgB;EC0gBhB,kBAAA;AA0UJ;AAvUE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cD1hBiB;ACm2BrB;AAvUI;EACE,eAAA;EACA,wBD1iBU;EC2iBV,cAAA;AAyUN;AAvUM;EAAI,iBAAA;EAAmB,eAAA;AA2U7B;AAxUI;EACE,eAAA;EACA,gBAAA;EACA,cDliBe;ECmiBf,iBAAA;AA0UN;AAtUE;EACE,OAAA;EACA,YAAA;AAwUJ;AAtUI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAwUN;AArUI;EACE,eAAA;EACA,WDnjBc;AC03BpB;AApUI;EACE,cAAA;EACA,eAAA;EACA,WDzjBc;EC0jBd,eAAA;AAsUN;AAlUE;EACE,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAoUJ;AAlUI;EACE,eAAA;EACA,wBDzlBU;AC65BhB;AAjUI;EACE,wBD7lBU;ACg6BhB;AA/TE;EACE,eAAA;EACA,WDhlBgB;ECilBhB,gBAAA;AAiUJ;AA9TE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBDzlBkB;EC0lBlB,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrmBiB;ACq6BrB;AA9TI;EACE,WDjmBc;ECkmBd,eAAA;AAgUN;AA5TE;EACE,WAAA;EACA,mBDjmBW;ECkmBX,aAAA;AA8TJ;;AAtTA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAyTF;;AAlTA;EACE,aAAA;AAqTF;;AA9SA;EACE;IAAW,aAAA;EAkTX;EAjTA;IAAsB,wBAAA;EAoTtB;EAnTA;IAAa,gCAAA;EAsTb;EArTA;IAAW,mBAAA;EAwTX;EAvTA;;;IAE0B,wBAAA;EA0T1B;EAzTA;IAA2B,2BAAA;EA4T3B;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../../assets/styles/variables';\n\n// ─────────────────────────────────────────────\n// Page Layout\n// ─────────────────────────────────────────────\n\n.od-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// ─────────────────────────────────────────────\n// Header\n// ─────────────────────────────────────────────\n\n.od-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 28px;\n  gap: 16px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n\n  &__left { flex: 1; }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 8px;\n  }\n\n  &__title {\n    font-size: 26px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    font-family: $font-stack;\n\n    @media (max-width: 640px) { font-size: 20px; }\n  }\n\n  &__check {\n    color: $develop-color;\n    font-size: 24px;\n  }\n\n  &__order-num {\n    color: $clarify-color;\n    font-weight: 700;\n  }\n\n  &__meta {\n    display: flex;\n    gap: 20px;\n    font-size: 13px;\n    color: $body-content-color;\n\n    &-item {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      strong {\n        color: $color-neutral-dark;\n      }\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Breadcrumb\n// ─────────────────────────────────────────────\n\n.od-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after {\n      content: '/';\n      margin: 0 8px;\n      color: $color-neutral-mid;\n    }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n\n      &:hover { color: $clarify-color; }\n    }\n\n    &.od-breadcrumb__current {\n      color: $color-neutral-dark;\n      font-weight: 600;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Buttons\n// ─────────────────────────────────────────────\n\n.od-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n\n    &:hover {\n      background: $color-dark-green;\n      color: #fff;\n    }\n  }\n\n  &--secondary {\n    background: #fff;\n    color: $body-content-color;\n    border-color: $color-grey-1;\n\n    &:hover {\n      background: $color-neutral-light;\n      border-color: $color-neutral-mid;\n    }\n  }\n\n  &--xs {\n    padding: 4px 10px;\n    font-size: 11px;\n    border-radius: 4px;\n    background: rgba($clarify-color, 0.08);\n    color: $clarify-color;\n    border-color: rgba($clarify-color, 0.15);\n\n    &:hover {\n      background: $clarify-color;\n      color: #fff;\n    }\n\n    &.disabled {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Status Badge\n// ─────────────────────────────────────────────\n\n.od-status-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: capitalize;\n  border-radius: 3px;\n\n  &--paid {\n    color: $develop-color;\n    background: rgba($develop-color, 0.1);\n  }\n\n  &--processing {\n    color: $clarify-color;\n    background: rgba($clarify-color, 0.1);\n  }\n\n  &--cancelled {\n    color: $implement-color;\n    background: rgba($implement-color, 0.1);\n  }\n}\n\n// ─────────────────────────────────────────────\n// Layout (main + sidebar)\n// ─────────────────────────────────────────────\n\n.od-layout {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 24px;\n  align-items: start;\n\n  @media (max-width: 991px) {\n    grid-template-columns: 1fr;\n  }\n\n  &__main { min-width: 0; }\n  &__sidebar { min-width: 0; }\n}\n\n// ─────────────────────────────────────────────\n// Cards\n// ─────────────────────────────────────────────\n\n.od-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  overflow: hidden;\n\n  &--half {\n    flex: 1;\n    min-width: 250px;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 20px;\n    background: $color-neutral-light;\n    border-bottom: 1px solid $color-grey-1;\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    font-family: $font-stack;\n  }\n\n  &__badge {\n    font-size: 12px;\n    font-weight: 600;\n    color: $body-content-color;\n    background: #fff;\n    padding: 2px 10px;\n    border-radius: 10px;\n    border: 1px solid $color-grey-1;\n  }\n\n  &__body {\n    padding: 20px;\n\n    &--table {\n      padding: 0;\n    }\n  }\n}\n\n// ─────────────────────────────────────────────\n// Product Card Layout\n// ─────────────────────────────────────────────\n\n.od-product {\n  display: flex;\n  gap: 16px;\n  padding: 16px 20px;\n  border-bottom: 1px solid $color-grey-1;\n  transition: background 0.1s ease;\n\n  &:last-child { border-bottom: none; }\n  &:hover { background: rgba($clarify-color, 0.015); }\n\n  &__img {\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: $color-neutral-light;\n    flex-shrink: 0;\n    border: 1px solid $color-grey-1;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &--comp {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba($develop-color, 0.06);\n      border-color: rgba($develop-color, 0.15);\n      color: $develop-color;\n      font-size: 20px;\n    }\n  }\n\n  &__body {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 600;\n    color: $color-neutral-dark;\n    margin: 0 0 6px;\n    cursor: pointer;\n    transition: color 0.15s ease;\n    line-height: 1.3;\n\n    &:hover { color: $clarify-color; }\n\n    &--comp {\n      color: $color-neutral-mid;\n      cursor: pointer;\n    }\n  }\n\n  &__comp-tag {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 3px;\n    background: rgba($develop-color, 0.08);\n    color: $develop-color;\n    margin-left: 6px;\n    vertical-align: middle;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  &__variants {\n    margin-top: 4px;\n  }\n\n  &__variant-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px 16px;\n    margin-bottom: 4px;\n  }\n\n  &__variant-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 12px;\n    color: $body-content-color;\n    font-family: $font-stack;\n\n    i {\n      font-size: 10px;\n      color: $color-neutral-mid;\n      width: 12px;\n      text-align: center;\n    }\n\n    strong {\n      font-weight: 600;\n      color: $color-neutral-dark;\n    }\n\n    &--savings {\n      color: $develop-color;\n      i, strong { color: $develop-color; }\n    }\n\n    &--promo {\n      color: $implement-color;\n      i, strong { color: $implement-color; }\n    }\n  }\n\n  &__admin-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    margin-top: 8px;\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 4px;\n    background: rgba($clarify-color, 0.08);\n    color: $clarify-color;\n    border: 1px solid rgba($clarify-color, 0.15);\n    text-decoration: none;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: $clarify-color;\n      color: #fff;\n    }\n  }\n\n  &__downloads {\n    margin-top: 10px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  &__dl-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 5px 12px;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 4px;\n    background: rgba($develop-color, 0.08);\n    color: $develop-color;\n    border: 1px solid rgba($develop-color, 0.15);\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background: $develop-color;\n      color: #fff;\n    }\n\n    &.disabled {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n  }\n\n  &__pending {\n    margin-top: 8px;\n    font-size: 12px;\n    color: $ideate-color;\n\n    i { margin-right: 4px; }\n\n    a {\n      color: $clarify-color;\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n\n  &__price-col {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    flex-shrink: 0;\n    min-width: 80px;\n  }\n\n  &__qty {\n    font-size: 11px;\n    color: $color-neutral-mid;\n    margin-bottom: 2px;\n  }\n\n  &__price {\n    font-size: 15px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    font-variant-numeric: tabular-nums;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Addresses\n// ─────────────────────────────────────────────\n\n.od-addresses {\n  display: flex;\n  gap: 16px;\n  margin-top: 20px;\n\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n}\n\n.od-address {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 13px;\n  color: $body-content-color;\n  line-height: 1.5;\n\n  strong {\n    color: $color-neutral-dark;\n    font-size: 14px;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Invoice Summary\n// ─────────────────────────────────────────────\n\n.od-card--sticky {\n  position: sticky;\n  top: 20px;\n}\n\n.od-card__header--accent {\n  background: $color-neutral-dark;\n  border-bottom-color: $color-neutral-dark;\n\n  .od-card__title {\n    color: #fff;\n\n    i { margin-right: 6px; opacity: 0.7; }\n  }\n}\n\n.od-invoice {\n  &__info {\n    margin-bottom: 4px;\n  }\n\n  &__info-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 3px 0;\n    font-size: 12px;\n  }\n\n  &__info-label {\n    color: $color-neutral-mid;\n    font-weight: 500;\n  }\n\n  &__info-value {\n    color: $color-neutral-dark;\n    font-weight: 600;\n  }\n\n  &__section-label {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: $color-neutral-mid;\n    margin-bottom: 6px;\n  }\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 6px 0;\n    font-size: 13px;\n    color: $body-content-color;\n\n    &--discount {\n      font-size: 12px;\n      color: $develop-color;\n      padding: 2px 0;\n\n      i { margin-right: 3px; font-size: 10px; }\n    }\n\n    &--total {\n      font-size: 16px;\n      font-weight: 700;\n      color: $color-neutral-dark;\n      padding-top: 10px;\n    }\n  }\n\n  &__product {\n    flex: 1;\n    min-width: 0;\n\n    &-name {\n      display: block;\n      font-size: 13px;\n      font-weight: 500;\n      margin-bottom: 2px;\n      line-height: 1.3;\n    }\n\n    &-qty {\n      font-size: 11px;\n      color: $color-neutral-mid;\n    }\n\n    &-unit {\n      display: block;\n      font-size: 10px;\n      color: $color-neutral-mid;\n      margin-top: 1px;\n    }\n  }\n\n  &__amount {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n    margin-left: 12px;\n\n    &--total {\n      font-size: 18px;\n      color: $develop-color;\n    }\n\n    &--discount {\n      color: $develop-color;\n    }\n  }\n\n  &__ship-method {\n    font-size: 11px;\n    color: $color-neutral-mid;\n    font-weight: 400;\n  }\n\n  &__payment-method {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 12px;\n    padding: 8px 12px;\n    background: $color-neutral-light;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 500;\n    color: $body-content-color;\n\n    i {\n      color: $color-neutral-mid;\n      font-size: 14px;\n    }\n  }\n\n  &__divider {\n    height: 1px;\n    background: $color-grey-1;\n    margin: 8px 0;\n  }\n}\n\n// ─────────────────────────────────────────────\n// Loader\n// ─────────────────────────────────────────────\n\n.od-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  padding: 60px 20px;\n}\n\n// ─────────────────────────────────────────────\n// PDF Modal\n// ─────────────────────────────────────────────\n\n.pdf-modal {\n  display: none;\n}\n\n// ─────────────────────────────────────────────\n// Print Styles\n// ─────────────────────────────────────────────\n\n@media print {\n  .od-page { padding: 20px; }\n  .od-header__actions { display: none !important; }\n  .od-layout { grid-template-columns: 1fr 300px; }\n  .od-card { break-inside: avoid; }\n  .od-product__downloads,\n  .od-product__pending,\n  .od-product__admin-link { display: none !important; }\n  .od-card__header--accent { background: #333 !important; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
